module.exports = __webpack_public_path__ + "static/media/molex_white.c204bb36.png";